import { Layout, Menu, Divider } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";

import { useMenuPath } from "../hooks";
import Logo from "../monitor_trade.png";
import menuPathItems from "./paths";
import styles from "./styles.less";

const { Item: MenuItem, SubMenu } = Menu;

interface IProps {
  collapsed: boolean;
  setCollapsed: (e: boolean) => void;
}

export default ({ collapsed, setCollapsed }: IProps) => {
  const defaultKey = useMenuPath().pathItem.title;

  return (
    <Layout.Sider
      collapsed={collapsed}
      theme="light"
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      <div className={styles.logo}>
        <img className={collapsed ? styles.collapsed : styles.full} src={Logo} alt="lgo" />
      </div>
      <Divider style={{ margin: 0 }} />
      <Avatar
        style={{ height: 35, width: 35, margin: "10px 20px" }}
        src={"https://material-ui.com/static/images/avatar/2.jpg"}
      />

      <Divider style={{ margin: 0 }} />
      <Menu
        className={styles.menuList}
        mode="inline"
        selectedKeys={[defaultKey]}
      >
        {menuPathItems.map(item => {
          switch (item.paths.length) {
            case 0:
              return null;
            case 1: {
              const { path, disabled } = item.paths[0];

              return (
                <MenuItem key={item.title} disabled={typeof disabled === "function" ? disabled() : disabled}>
                  <Link to={cleanPath(path)}>
                    {React.createElement(item.icon)}
                    <span>{item.title}</span>
                  </Link>
                </MenuItem>
              );
            }
            default:
              return (
                <SubMenu
                  key={item.title}
                  title={
                    <span>
                      {React.createElement(item.icon)}
                      <span>{item.title}</span>
                    </span>
                  }
                >
                  {item.paths.map(({ disabled, path, title }) => (
                    <MenuItem key={title} disabled={typeof disabled === "function" ? disabled() : disabled}>
                      <Link to={cleanPath(path)}>{title}</Link>
                    </MenuItem>
                  ))}
                </SubMenu>
              );
          }
        })}
      </Menu>
    </Layout.Sider>
  );

  function cleanPath(path: string) {
    return path
      .split("/")
      .filter(e => !e.startsWith(":"))
      .join("/");
  }
};
